"use client";

import { TitleH2 } from "@/components/shared/public";
import { Link } from "@/i18n/navigation";
import { BUSINESS_INFO } from "@/lib/business-info";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { logoImmoMates } from "../../../../../public/images/logos";

const Impressum = () => {
  const t = useTranslations("common");
  const tI = useTranslations("imprint");

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-10">
        <div className="flex flex-col justify-between lg:flex-row lg:items-center">
          <div className="text-ring flex flex-col gap-5 text-lg">
            <TitleH2 title={t("responsible")} />

            <div>
              <p>{BUSINESS_INFO.legalName}</p>
              <p>
                {t("ceo")}: {BUSINESS_INFO.ceo}
              </p>
              <p>{BUSINESS_INFO.street}</p>
              <p>
                {BUSINESS_INFO.postalCode} {BUSINESS_INFO.city}
              </p>
            </div>

            <div>
              <p>{t("localCourt")}</p>
              <p>{BUSINESS_INFO.commercialRegister}</p>
            </div>

            <div>
              <p>Telefon: {BUSINESS_INFO.phoneDisplay}</p>
              <p>E-Mail: {BUSINESS_INFO.email}</p>
            </div>

            <p>USt-ID-Nr.: {BUSINESS_INFO.vatId}</p>
          </div>
          <div className="text-ring flex flex-col gap-2 text-lg">
            <p>{tI("brandOf")}</p>
            <Link
              href="https://www.immomates.de/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={logoImmoMates}
                alt={"Logo ImmoMates GmbH"}
                className="lg:w-[540px]"
              />
            </Link>
          </div>
        </div>

        <div className="text-ring flex flex-col gap-10 text-lg">
          <p>
            {tI("disputeResolution")}{" "}
            <Link
              className="hover:text-primary font-medium hover:underline"
              href="https://ec.europa.eu/consumers/odr/finden"
            >
              https://ec.europa.eu/consumers/odr/finden
            </Link>
            .
          </p>
          <div className="flex flex-col gap-5">
            <TitleH2 title={tI("disclaimer")} />
            <p>{tI("disclaimerText")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
